export default {
  sm: `
  데이터센터 각은 데이터를 활용한 새로운 가치 창출을
  통해 미래 세대와 데이터 시대를 준비하고 있습니다.
  `,
  lg: `
  데이터센터 각은 데이터를 활용한 새로운 가치 창출을 통해
  미래 세대와 데이터 시대를 준비하고 있습니다.
  `
};
